export default __webpack_public_path__ + "static/media/009.8ec61a2e.jpg";